import React, { useState } from 'react';
import { EmmarRgisterModal } from './EmmarRgisterModal';

export const RegisterButton = () => {
  const [showModal, setShowModal] = useState(false);

  return (
    <div
      style={{
        display:        'flex',
        justifyContent: 'center',
        alignItems:     'center',
        width:          '100%',
        margin:'5px'
      }}
    >
      <button
        onClick={() => setShowModal(true)}
        style={{
          background:    '#c8a04a',
          color:         '#fff',
          border:        'none',
          borderRadius:  '50px',
          padding:       '16px 48px',
          fontSize:      'clamp(15px, 1.8vw, 18px)',
          fontWeight:    '700',
          fontFamily:    "'Cairo', sans-serif",
          cursor:        'pointer',
          letterSpacing: '0.5px',
          boxShadow:     '0 4px 24px rgba(200,160,74,0.45)',
          transition:    'background 0.3s ease, box-shadow 0.3s ease',
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.background = '#b8903a';
          e.currentTarget.style.boxShadow  = '0 6px 32px rgba(200,160,74,0.65)';
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.background = '#c8a04a';
          e.currentTarget.style.boxShadow  = '0 4px 24px rgba(200,160,74,0.45)';
        }}
      >
        تواصل معنا
      </button>

      <EmmarRgisterModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </div>
  );
};